import { z } from 'zod/v3';
import { LabelColorSchema } from '../generated/enums';

// Label DTO
export const LabelDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: LabelColorSchema,
});

export type LabelDTO = z.infer<typeof LabelDTOSchema>;

// Input schemas
export const CreateLabelInputSchema = z.object({
  name: z.string().min(1).max(50),
  color: LabelColorSchema.optional().default('GREY'),
});

export type CreateLabelInput = z.infer<typeof CreateLabelInputSchema>;

export const UpdateLabelInputSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(50).optional(),
  color: LabelColorSchema.optional(),
});

export type UpdateLabelInput = z.infer<typeof UpdateLabelInputSchema>;

export const SetLabelsInputSchema = z.object({
  labelIds: z.array(z.string()),
});

export type SetLabelsInput = z.infer<typeof SetLabelsInputSchema>;
